import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Container, PrimaryButton } from '../../components/pbg-ui-library';
import { formatMessage } from '../../../lib/intl';
import loginWithFacebook from '../../../lib/login-with-facebook';
import { EMAIL, INVITEE } from '../../../lib/account-types';

import InlineSignIn from './inline-sign-in';
import { i18n } from './contact-information.i18n';

class ContactInformation extends React.PureComponent {
  formatMessage = formatMessage(this.props.intl ? this.props.intl : {});

  static propTypes = {
    user: PropTypes.object,
    accountType: PropTypes.string,
    signIn: PropTypes.bool,
    onLogout: PropTypes.func.isRequired,
    onSignIn: PropTypes.func.isRequired,
    onSendLink: PropTypes.func.isRequired,
    onCreateAccount: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: null,
    accountType: INVITEE,
  };

  get shouldRenderSignin() {
    return this.props.signIn;
  }

  onLogout = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    const { onLogout } = this.props;
    onLogout();
  }

  onSignIn = () => {
    const { onSignIn } = this.props;
    onSignIn();
  }

  onCreateAccount = () => {
    const { onCreateAccount } = this.props;
    onCreateAccount();
  }

  onForgotPassword = () => {
    window.open('/password-reset', '_blank');
  }

  onFacebookClick = () => {
    const { authentication, connectWithFacebook } = this.props;

    return loginWithFacebook({
      authentication,
      connectWithFacebook,
      onConnect: () => { },
      onError: () => alert('Error signing up with Facebook'),
    });
  }

  renderSignin() {
    const { accountType, onSendLink, } = this.props;

    return (
      <React.Fragment>
        <div className="dont-have-an-account">
          <span className="pbg-consumer-desktop pbg-desktop-paragraph">
            {this.formatMessage(i18n.nevemind)}
          </span>
          {' '}
          <span className="pbg-consumer-desktop pbg-desktop-label-link signin-link" onClick={this.onCreateAccount}>
            {this.formatMessage(i18n.iDontHaveAnAccount)}
          </span>
        </div>
        <InlineSignIn
          accountType={accountType}
          allowCreateAccount={false}
          onFacebookClick={this.onFacebookClick()}
          onForgotPassword={this.onForgotPassword}
          onSendLink={onSendLink}
          onSignIn={this.onSignIn}
        />
        {(accountType === EMAIL || accountType === INVITEE) &&
          <div className="contact-information-signin-footer">
            <div className="sign-in-button">
              <PrimaryButton>{this.formatMessage(i18n.signIn)}</PrimaryButton>
            </div>
          </div>
        }
      </React.Fragment>
    )
  }

  renderLoggedIn() {
    const { user } = this.props;
    return (
      <div className="contact-information-logged-in">
        You are logged in
        <Container solid className="contact-information-logged-in-container">
          <span className="pbg-consumer-desktop pbg-desktop-label-strong">{user.fullName}</span>
          <span className="pbg-consumer-desktop pbg-desktop-label-link logout-link" onClick={this.onLogout}>
            {this.formatMessage(i18n.logout)}
          </span>
        </Container>
      </div>
    );
  }

  renderUnauthenticated() {
    const { accountType, onSendLink } = this.props;

    return (
      <React.Fragment>
        <div className="have-an-account">
          <span className="pbg-consumer-desktop pbg-desktop-paragraph">
            {this.formatMessage(i18n.haveAnAccount)}
          </span>
          {' '}
          <span className="pbg-consumer-desktop pbg-desktop-label-link signin-link" onClick={this.onSignIn}>
            {this.formatMessage(i18n.signIn)}
          </span>
        </div>
        <InlineSignIn
          accountType={accountType}
          allowCreateAccount={true}
          onFacebookClick={this.onFacebookClick()}
          onForgotPassword={this.onForgotPassword}
          onSendLink={onSendLink}
          onSignIn={this.onSignIn}
        />
      </React.Fragment>
    );
  }

  render() {
    const { user } = this.props;
    if (user) return this.renderLoggedIn();
    if (this.shouldRenderSignin) return this.renderSignin();
    return this.renderUnauthenticated();
  }
}

export default injectIntl(ContactInformation);



// WEBPACK FOOTER //
// ./src/desktop/pages/single-payer-payment/contact-information.js